import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudtrailService } from '../../service';

export type LogFileValidationConfig = typeof LogFileValidationConfig._.Config;

export const LogFileValidationConfig = IntegrationConfig.make({
  service: CloudtrailService,
  name: Integration_Handler_Names_Enum.LogFileValidation,
  configSchema: z.object({}),
});
